import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "@material-ui/core/Checkbox";
import styled from "@emotion/styled";

const ColumnHeadingsWrapper = styled.div`
    display: grid;
    grid-template-columns: ${ props => `repeat(${props.columnCount}, 150px)`};
    grid-auto-flow: column;    
`;

const ColumnHeading = styled.span`
    display: flex;
    align-items: center;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: bold;
    font-size: var(--font-12);
    line-height: 12px;
    /* identical to box height */
    
    /* default/gray/600 */
    color: var(--color-gray-600);

    &:first-of-type {
    margin-left: ${props => (props.hasIndent) ? "var(--space-s1)" : "0"};
    grid-column-start: 1;
    }
`;


function ExpansionPanelTableHeadingComponent({tableHeadings, hasCheckBox, isChecked, onCheckBoxClicked, indeterminate}) {
    return (
        <ColumnHeadingsWrapper columnCount={tableHeadings.length}>
            {
                tableHeadings.length
                    ?
                    <>
                        {tableHeadings.slice(0, 1).map(firstHeading =>
                            <ColumnHeading hasIndent={!hasCheckBox} key={firstHeading.name}>
                            {
                                hasCheckBox
                                && <Checkbox
                                    indeterminate={indeterminate}
                                    value={"tableHeading"}
                                    checked={isChecked}
                                    onChange={onCheckBoxClicked}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}/>
                            }
                            {firstHeading.name}
                        </ColumnHeading>)}

                        {tableHeadings.slice(1).map(heading => <ColumnHeading
                            key={heading.name}>{heading.name}</ColumnHeading>)}
                    </>
                    : null
            }
        </ColumnHeadingsWrapper>
    );
}

ExpansionPanelTableHeadingComponent.propTypes = {};
ExpansionPanelTableHeadingComponent.defaultProps = {};

export default ExpansionPanelTableHeadingComponent;
